import Rollbar from 'rollbar';
const nodeEnv = process.env.REACT_APP_ENV;
export const RollbarErrorTracking = (() => {

    const RollbarObj = new Rollbar({
        enabled: (nodeEnv === 'production'),
        //accessToken: 'ee4c888a4aea4f95831adcfd9d0448d1',
        accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
        captureUncaught: true,
        captureUnhandledRejections: true,
        //payload: {environment: "production"}
    });

    const logInfo = (info, data) => {
        RollbarObj.info(info, data);
    };

    const logError = (info,data) => {
        RollbarObj.error(info,data);
    };

    const logErrorInRollbar = (error, data) => {
        if (error && data) {
            throw new Error(error, data);
        }
    };

    return { logInfo, logError, logErrorInRollbar };

})();
export default RollbarErrorTracking;